import { IApiResponseData } from "api/axios/types";
import { TSavingsType } from "api/individual-user-management/types";
import { TTransactionStatus } from "features/businesses/business-details/content/transactions/types";

import { TExportType } from "ui/export/types";
import { IPaginationData } from "ui/pagination/types";

// import { IFlexSavings } from "./../individual-user-management/types";

// import { TSavingsFrequency } from "./types";

// import { IUser } from "./../individual/types";

export interface IIndividualFlexSavingsStatsData {
  totalFlexSavingsAmount: number;
  totalWithdrawalAmount: number;
  totalInterestEarned: number;
  numberOfActiveFlexSavings: number;
  totalNumberOfFlexSavers: number;
}

export type TIndividualFlexSavingsStatsItemWithoutActiveSavers = Omit<
  TIndividualFlexSavingsStatsItem,
  "numberOfActiveFlexSavings"
>;

export interface IIndividualGoalSavingsStatsData {
  totalAmountSaved: number;
  totalInterestEarned: number;
  totalWithdrawal: number;
  totalActiveGoals: number;
  saversCount: number;
}

export type TIndividualGoalSavingsStatsItemWithoutActiveSavers = Omit<
  TIndividualGoalSavingsStatsItem,
  "totalActiveGoals"
>;

export interface IIndividualVaultSavingsStatsData {
  totalVaultSavingsAmount: number;
  totalWithdrawalAmount: number;
  totalInterestEarned: number;
  numberOfActiveVaultSavings: number;
  totalNumberOfVaultSavers: number;
}

export interface IUserDetailsData {
  email: string;
  phoneNumber: string;
}

export type TIndividualFlexSavingsStatsItem =
  keyof IIndividualFlexSavingsStatsData;
export type TIndividualGoalSavingsStatsItem =
  keyof IIndividualGoalSavingsStatsData;
export type TIndividualVaultSavingsStatsItem =
  keyof IIndividualVaultSavingsStatsData;

export interface IIndividualFlexSavingsStatsResponseDatas
  extends IApiResponseData<IIndividualFlexSavingsStatsData> {}

export interface IIndividualGoalSavingsStatsResponseDatas
  extends IApiResponseData<IIndividualGoalSavingsStatsData> {}

export interface IIndividualVaultSavingsStatsResponseDatas
  extends IApiResponseData<IIndividualVaultSavingsStatsData> {}

export interface IGetIndividualStatsPayload {
  dateRange?: string;
  startDate?: string;
  endDate?: string;
}

// Savings
export interface IIndividualFlexSavingsStatsPayload {
  startDate?: string;
  endDate?: string;
}

export interface IIndividualGoalSavingsStatsPayload {
  startDate?: string;
  endDate?: string;
}

export interface IIndividualVaultSavingsStatsPayload {
  startDate?: string;
  endDate?: string;
}

export interface IIndividualSavingsTransactionsStatsPayload {
  id: string;
  plan: TSavingsType;
  startDate?: string;
  endDate?: string;
}

export interface IIndividualSavingsTransactionsStats {
  totalSavingsAmount: number;
  totalWithdrawalAmount: number;
  totalInterestEarned: number;
}

export interface IIndividualFlexSavingsStats {
  totalFlexSavingsAmount: number;
  totalWithdrawalAmount: number;
  totalInterestEarned: number;
  numberOfActiveFlexSavings?: number;
  totalNumberOfFlexSavers: number;
}

export interface IIndividualGoalSavingsStats {
  totalAmountSaved: number;
  totalInterestEarned: number;
  totalWithdrawal: number;
  totalActiveGoals: number;
  saversCount: number;
}

export interface IIndividualVaultSavingsStats {
  totalFlexSavingsAmount: number;
  totalWithdrawalAmount: number;
  totalInterestEarned: number;
  numberOfActiveFlexSavings?: number;
  totalNumberOfFlexSavers: number;
}

export interface IIndividualSavingsTransactionsStatsResponseData
  extends IApiResponseData<IIndividualSavingsTransactionsStats> {}

export interface IIndividualFlexSavingsStatsResponseData
  extends IApiResponseData<IIndividualFlexSavingsStats> {}

export interface IIndividualGoalSavingsStatsResponseData
  extends IApiResponseData<IIndividualGoalSavingsStats> {}

export interface IIndividualVaultSavingsStatsResponseData
  extends IApiResponseData<IIndividualVaultSavingsStats> {}

// export type TSavingsStatus = "active" | "deleted";
export type TSavingsStatus =
  | "active"
  | "matured"
  | "completed"
  | "paused"
  | "stopped";

export type TSavingsFrequency = "daily" | "weekly" | "monthly";

export type TSavingsSource = "wallet" | "card";

export type TSavingsTransactionType = "savings" | "interest" | "withdrawal";

export interface IAutoSave {
  _id: {
    $oid: string;
  };
  createdAt: {
    $date: string; // ISO date string
  };
  updatedAt: {
    $date: string; // ISO date string
  };
}

export type AutoSave = {
  _id?: { $oid: string };
  createdAt?: { $date: string };
  updatedAt?: { $date: string };
  amount?: number;
  plan?: string;
  start_date?: { $date: string };
  end_date?: { $date: string };
  save_time?: string;
  is_active?: boolean;
  job_id?: string;
};

export interface IFlexSavings {
  id: string;
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  halal: boolean;
  wallet: string;
  walletId: string;
  amount: number;
  status: string;
  frequency: string | null;
  dayOfWeek: string | null;
  dayOfMonth: string | null;
  timeOfDay: string | null;
  startsAt: string | null;
  endsAt: string | null;
  withdrawalsLeft: number;
  description: string;
  hash: string;
  balance: number;
  flexInterest: number;
  source: string;
  isDeleted: boolean;
  isAutoSave: boolean;
  isAutoStart: boolean;
  cardId: string;
  interestRate: number;
  setupId: string;
  createdAt: string;
  updatedAt: string;
  runningDays: number;
  autoSave: AutoSave;
}

export enum GoalSavingsStatusEnum {
  ACTIVE = "active",
  STOPPED = "stopped",
  COMPLETED = "completed",
  DISBURSED = "disbursed",
  MATURED = "matured",
  DELETED = "deleted",
  PAUSED = "paused",
}

type GoalFrequency = "daily" | "weekly" | "monthly";

export interface IGoalSavings {
  id: string;
  amount: number;
  goal: string;
  firstName: string;
  lastName: string;
  email: string;
  source: string;
  halal: boolean;
  target: number;
  totalAmountSaved: number;
  startsAt: string; // ISO date string
  endsAt: string; // ISO date string
  totalInterest: number;
  frequency: GoalFrequency;
  status: GoalSavingsStatusEnum;
  createdAt: string; // ISO date string
}

export enum VaultSavingsStatusEnum {
  ACTIVE = "active",
  STOPPED = "stopped",
  COMPLETED = "completed",
  DISBURSED = "disbursed",
  MATURED = "matured",
  DELETED = "deleted",
  PAUSED = "paused",
}

export interface IVaultSavings {
  id: string;
  amount: number;
  walletId: number;
  maturityDate: string;
  startDate: string;
  name: string;
  rate: number;
  taxRate: number;
  interestToEarn: number;
  lockDuration: number;
  isInterestPaid: boolean;
  halal: boolean;
  status: VaultSavingsStatusEnum;
  userId: string;
  upfront: boolean;
  isMatured: boolean;
  createdAt: string;
  updatedAt: string;
  firstName: string;
  lastName: string;
  profileImage: string;
  email: string;
}

export interface IIndividualFlexSavingsPayload {
  walletId?: number;
  page: string;
  limit: string;
  search?: string;
  searchBy?: string;
  source?: TSavingsSource;
  status?: TSavingsStatus;
  frequency?: TSavingsFrequency;
  accountName?: string;
  startDate?: string;
  endDate?: string;
  isRefetching?: boolean;
  dateRange?: string;
}

export interface IIndividualFlexSavingsResult extends IPaginationData {
  data: IFlexSavings[];
}
export interface IIndividualFlexSavingsResponseData
  extends IApiResponseData<IIndividualFlexSavingsResult> {}

export interface IIndividualFlexSavingsDetailsPayload {
  id: string;
}

export interface IFlexSavingsDetails {
  savingsTrails: any[];
  id: string;
  userId: string;
  wallet: string;
  walletId: string;
  amount: number;
  status: TSavingsStatus;
  frequency: TSavingsFrequency | null;
  dayOfWeek: number | null;
  dayOfMonth: number | null;
  timeOfDay: string | null;
  startsAt: string | null;
  endsAt: string | null;
  withdrawalsLeft: number;
  description: string;
  hash: string;
  balance: number;
  flexInterest: number;
  source: string;
  isDeleted: boolean;
  isAutoSave: boolean;
  isAutoStart: boolean;
  cardId: string;
  interestRate: number;
  setupId: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  runningDays: number;
  autoSave: IAutoSave | null;
}

export interface IIndividualFlexSavingsDetailsResult {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  accountNumber: number;
  accountTier: number;
  halal: boolean;
  data: IFlexSavingsDetails;
}

export interface IIndividualFlexSavingsDetailsResponseData
  extends IApiResponseData<IIndividualFlexSavingsDetailsResult> {}

export interface IIndividualFlexSavingsHistoryPayload {
  flexSaving: string;
  page: string;
  limit: string;
  type?: string;
  search?: string;
  searchBy?: string;
  source?: TSavingsSource;
  status?: TSavingsStatus;
  frequency?: TSavingsFrequency;
  accountName?: string;
  startDate?: string;
  endDate?: string;
  isRefetching?: boolean;
}

export type TFlexSavingsType = "interest" | "savings" | "withdrawal" | "tax";

export interface IFlexSavingsHistory {
  id: string;
  userId: string;
  flexSaving: string;
  type: TFlexSavingsType;
  amount: number;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  ref: string;
  status: string;
  sourceType: string | null;
  previousBalance: number;
  newBalance: number;
  description: string;
  meta: any | null;
  isDeleted: boolean;
}

export interface IIndividualFlexSavingsHistoryResult {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  data: IPaginationData & { data: IFlexSavingsHistory[] };
}
export interface IIndividualFlexSavingsHistoryResponseData
  extends IApiResponseData<IIndividualFlexSavingsHistoryResult> {}

export interface IIndividualGoalSavingsPayload {
  walletId?: number;
  page: string;
  limit: string;
  search?: string;
  searchBy?: string;
  source?: TSavingsSource;
  status?: GoalSavingsStatusEnum;
  frequency?: TSavingsFrequency;
  accountName?: string;
  startDate?: string;
  endDate?: string;
  isRefetching?: boolean;
}

export interface IGetIndividualVaultSavingsPayload {
  page: string;
  limit: string;
  search?: string;
  searchBy?: string;
  startDate?: string;
  endDate?: string;
  status?: string;
  lockDuration?: string;
}

export interface IIndividualGoalSavingsPayload {
  walletId?: number;
  page: string;
  limit: string;
  search?: string;
  searchBy?: string;
  source?: TSavingsSource;
  status?: GoalSavingsStatusEnum;
  accountName?: string;
  startDate?: string;
  endDate?: string;
  isRefetching?: boolean;
}

export interface IIndividualGoalSavingsResult extends IPaginationData {
  data: IGoalSavings[];
  email: string;
  firstName: string;
  lastName: string;
}

export interface IIndividualGoalSavingsResponseData
  extends IApiResponseData<IIndividualGoalSavingsResult> {}

export interface IIndividualGoalSavingsDetailsPayload {
  goalId?: string;
}

interface IGoalSavingsDetails {
  id: string;
  goal: string;
  walletId: string;
  wallet: string;
  categoryId: string;
  userId: string;
  description: string;
  target: number;
  status: GoalSavingsStatusEnum;
  type: "target" | "savings" | "other";
  startsAt: string; // ISO date string
  endsAt: string; // ISO date string
  hash: string;
  completedAt: string | null;
  disbursedAt: string | null;
  setup: string | null;
  source: string;
  isDeleted: boolean;
  cardId: string | null;
  setupId: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  totalInterest: number;
  totalAmountSaved: number;
  frequency: TSavingsFrequency | null;
  dayOfWeek: number | null;
  dayOfMonth: number | null;
  timeOfDay: number | null;
  amount: number;
  resumedAt: string | null;
  pausedAt: string | null;
  interestRate: number;
  breakingFee: number;
  disbursedAmount: number;
  isLock: boolean;
  runningDays: number;
}

export interface IIndividualGoalSavingsDetailsResult extends IPaginationData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  halal: boolean;
  accountTier: number;
  accountNumber: number;
  goal: IGoalSavingsDetails;
}
export interface IIndividualGoalSavingsDetailsResponseData
  extends IApiResponseData<IIndividualGoalSavingsDetailsResult> {}

export interface IIndividualGoalSavingsHistoryPayload {
  goalId: string;
  page: string;
  limit: string;
  type?: string;
  search?: string;
  searchBy?: string;
  source?: TSavingsSource;
  status?: GoalSavingsStatusEnum;
  frequency?: TSavingsFrequency;
  accountName?: string;
  startDate?: string;
  endDate?: string;
  isRefetching?: boolean;
}

export enum GoalSavingsTransactionType {
  SAVINGS = "savings",
  INTEREST = "interest",
  WITHDRAWAL = "withdrawal",
}

export enum GoalSavingsTransactionStatus {
  SUCCESS = "success",
  FAILED = "failed",
}

export interface IGoalSavingsHistory {
  id: string;
  userId: string;
  goal: string;
  type: GoalSavingsTransactionType;
  amount: number;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  ref: string;
  status: GoalSavingsTransactionStatus;
  sourceType: TSavingsSource | null; // Nullable source type
  previousBalance: number;
  newBalance: number;
  description: string;
  meta: any | null;
  isDeleted: boolean | null;
}

export interface IIndividualGoalSavingsHistoryResult extends IPaginationData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  data: IGoalSavingsHistory[];
  // data: IPaginationData & { data: IGoalSavingsHistory[] };
}
export interface IIndividualGoalSavingsHistoryResponseData
  extends IApiResponseData<IIndividualGoalSavingsHistoryResult> {}

export enum IndividualVaultSavingsStatusEnum {
  ACTIVE = "active",
  COMPLETED = "completed",
}

export interface IIndividualVaultSavingsResult extends IPaginationData {
  data: IVaultSavings[];
}
export interface IIndividualVaultSavingsResponseData
  extends IApiResponseData<IIndividualVaultSavingsResult> {}

export interface IIndividualSavingsDetailsPayload {
  id: string;
  plan: TSavingsType;
}

export interface IIndividualSavingsFlexDetailsResult {
  id: string;
  userId: string;
  wallet: string;
  walletId: string;
  amount: number;
  status: "active" | "inactive" | "paused" | "closed"; // Add more statuses if needed
  frequency: string | null;
  dayOfWeek: string | null;
  dayOfMonth: number | null;
  timeOfDay: string | null;
  startsAt: string | null; // ISO date string
  endsAt: string | null; // ISO date string
  withdrawalsLeft: number;
  description: string | null;
  hash: string;
  balance: number;
  flexInterest: number;
  source: "wallet" | "bank" | "other"; // Add more sources if applicable
  isDeleted: boolean;
  isAutoSave: boolean;
  isAutoStart: boolean;
  cardId: string;
  interestRate: number;
  setupId: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  runningDays: number;
  autoSave: Record<string, unknown>; // Assuming autoSave can be any object
  user: ISavingsUser;
}

export interface IIndividualSavingsGoalDetailsResult {
  id: string;
  goal: string;
  walletId: string;
  wallet: string | null;
  categoryId: string;
  userId: string;
  description: string;
  target: number;
  status: "active" | "inactive" | "paused" | "deleted" | "completed";
  type: "target" | "flex" | "goal";
  startsAt: string; // ISO 8601 Date string
  endsAt: string; // ISO 8601 Date string
  hash: string;
  completedAt: string | null;
  disbursedAt: string | null;
  setup: string | null;
  source: "wallet" | "bank" | "card";
  isDeleted: boolean;
  cardId: string | null;
  setupId: string;
  createdAt: string; // ISO 8601 Date string
  updatedAt: string; // ISO 8601 Date string
  runningDays: number;
  totalInterest: number;
  totalAmountSaved: number;
  frequency: "daily" | "weekly" | "monthly" | "yearly";
  dayOfWeek: string | null;
  dayOfMonth: number | null;
  timeOfDay: number | null;
  amount: number;
  resumedAt: string | null;
  pausedAt: string | null;
  interestRate: number;
  breakingFee: number;
  disbursedAmount: number | null;
  user: ISavingsUser;
}

export interface IIndividualVaultSavingsHistoryPayload {
  flexSaving: string;
  page: string;
  limit: string;
  type?: string;
  search?: string;
  searchBy?: string;
  source?: TSavingsSource;
  status?: TSavingsStatus;
  frequency?: TSavingsFrequency;
  accountName?: string;
  startDate?: string;
  endDate?: string;
  isRefetching?: boolean;
}

export interface IVaultSavingsHistory {
  id: string;
  userId: string;
  flexSaving: string;
  type: string;
  amount: number;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  ref: string;
  status: string;
  sourceType: string | null;
  previousBalance: number;
  newBalance: number;
  description: string;
  meta: any | null;
  isDeleted: boolean;
}

export interface IIndividualVaultSavingsHistoryResult extends IPaginationData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  data: IVaultSavingsHistory;
}
export interface IIndividualVaultSavingsHistoryResponseData
  extends IApiResponseData<IIndividualVaultSavingsHistoryResult> {}

export interface ISavingsUser {
  email: string;
  accountNumber: string;
  accountTier: number;
  firstName: string;
  lastName: string;
  applyHalal: boolean;
  phoneNumber?: string;
}

export interface IIndividualSavingsDetailsResponseData
  extends IApiResponseData<
    IIndividualSavingsGoalDetailsResult | IIndividualSavingsFlexDetailsResult
  > {}

export interface IIndividualSavingsHistoryPayload {
  id: string;
  plan: TSavingsType;
  page: string;
  limit: string;
  status?: TTransactionStatus | string;
  type?: TSavingsTransactionType | string;
  search?: string;
  searchBy?: string;
  startDate?: string;
  endDate?: string;
  isRefetching?: boolean;
}

export interface IIndividualSavingsGoalHistoryResult {
  id: string;
  userId: string;
  goal?: string; // Optional, since "goal" exists in some cases
  flexSaving?: string; // Optional, since "flexSaving" exists in some cases
  type: "savings" | "interest";
  amount: number;
  createdAt: string;
  updatedAt: string;
  ref: string;
  status: "success" | "pending" | "failed"; // Based on possible values
  previousBalance: number;
  newBalance: number;
  description: string;
  meta: any | null;
  isDeleted: boolean | null;
}
export interface IPauseIndividualSavingsPayload {
  id: string;
  plan: TSavingsType;
  reason?: string;
  attachment?: string;
}

export interface IPauseIndividualSavingsResponseData
  extends IApiResponseData<{ data: null }> {}

export interface IResumeIndividualSavingsPayload {
  id: string;
  plan: TSavingsType;
  reason?: string;
  attachment?: string;
}

export interface IResumeIndividualSavingsResponseData
  extends IApiResponseData<{ data: null }> {}

//export
export type TExportOptionsType =
  | "account_transaction"
  | "payroll"
  | "business_transaction"
  | "yield";

export interface IExportPayload {
  startDate: string;
  endDate: string;
  format: TExportType;
}

export interface IExportResponseData
  extends IApiResponseData<{
    type: string;
    data: number[];
  }> {}

export interface IExportFlexSavingsPayload extends IExportPayload {
  // walletId: number;
}

export interface IExportGoalSavingsPayload extends IExportPayload {
  // walletId: number;
}

export interface IExportVaultSavingsPayload extends IExportPayload {
  // walletId: number;
}

export interface IGetIndividualVaultSavingsDetailsPayload {
  vaultId: string;
}

export interface IIndividualVaultSavingsDetails {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  accountNumber: string;
  data: {
    id: string;
    amount: number;
    walletId: number;
    maturityDate: string;
    startDate: string;
    name: string;
    rate: number;
    taxRate: number;
    interestToEarn: number;
    lockDuration: number;
    isInterestPaid: boolean;
    halal: boolean;
    status: string;
    userId: string;
    upfront: boolean;
    isMatured: boolean;
    createdAt: string;
    updatedAt: string;
  };
}
export interface IIndividualVaultSavingsDetailsResponseData
  extends IApiResponseData<IIndividualVaultSavingsDetails> {}

export interface IGetIndividualVaultSavingsTransactionsPayload {
  vaultId: string;
  page: string;
  limit: string;
  startDate?: string;
  endDate?: string;
  search?: string;
  searchBy?: string;
}

export interface IIndividualVaultSavingsTransaction {
  id: string;
  vaultId: string;
  amount: number;
  reference: string;
  status: string;
  type: string;
  product: string;
  createdAt: string;
  updatedAt: string;
}

export interface IIndividualVaultSavingsTransactionsResult
  extends IPaginationData {
  data: IIndividualVaultSavingsTransaction[];
}

export interface IIndividualVaultSavingsTransactionResponseData
  extends IApiResponseData<IIndividualVaultSavingsTransactionsResult> {}

export interface IGetIndividualVaultSavingsTransactionsStatsPayload {
  vaultId: string;
  startDate?: string;
  endDate?: string;
}

export interface IIndividualVaultSavingsTransactionsStats {
  totalSavingsAmount: number;
  totalWithdrawalAmount: number;
  totalInterestEarned: number;
}
export interface IIndividualVaultSavingsTransactionsStatsResponseData
  extends IApiResponseData<IIndividualVaultSavingsTransactionsStats> {}

export interface IIndividualSavingsCount {
  flexCount: number;
  goalCount: number;
  vaultCount: number;
}

export interface IIndividualSavingsCountResponseData
  extends IApiResponseData<IIndividualSavingsCount> {}
